import * as React from 'react';

import {useDisclaimer} from './use-disclaimer';
import {ReferenceBadge} from '@volkswagen-onehub/components-core';
import {I18nKey} from '@volkswagen-onehub/car-technical-details-schemas';
import {useTranslate} from '../utils/translate';

export interface DisclaimerReferenceProps {
  readonly disclaimerKey?: I18nKey;
}

export function DisclaimerReference({
  disclaimerKey,
}: DisclaimerReferenceProps): JSX.Element | null {
  const translate = useTranslate();
  const disclaimer = useDisclaimer(disclaimerKey);

  if (!disclaimer) {
    return null;
  }

  return (
    <sup>
      &nbsp;
      <ReferenceBadge
        onClick={(event) => {
          if (disclaimer.onClick) {
            event.preventDefault();
            event.stopPropagation();
            disclaimer.onClick();
          }
        }}
        aria-label={`${translate('disclaimer.badge.aria.label')} ${
          disclaimer.reference
        }`}
      >
        {disclaimer.reference}
      </ReferenceBadge>
    </sup>
  );
}
